/**
 * 🔐 AuthContext 통합 Axios 인스턴스
 * FSD shared layer - 모든 도메인 API 클라이언트에서 사용할 공통 axios 인스턴스
 * 
 * @example
 * ```ts
 * // Orval 설정에서 사용
 * import { createAuthAxiosInstance } from '@edusense/shared-auth-core/axios';
 * 
 * export const customInstance = createAuthAxiosInstance({
 *   baseURL: 'https://api.example.com',
 * });
 * ```
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios, { AxiosHeaders } from 'axios';
import { tokenManager } from '../token-manager';
var XSRF_COOKIE_NAME = 'XSRF-TOKEN';
var XSRF_HEADER_NAME = 'X-XSRF-TOKEN';
var isBrowserEnvironment = typeof document !== 'undefined';
var unsafeMethods = new Set([
    'post',
    'put',
    'patch',
    'delete'
]);
var getCookieValue = function(cookieName) {
    if (!isBrowserEnvironment) {
        return null;
    }
    var cookies = document.cookie ? document.cookie.split(';') : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = cookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var rawCookie = _step.value;
            var _rawCookie_trim_split = _to_array(rawCookie.trim().split('=')), name = _rawCookie_trim_split[0], valueParts = _rawCookie_trim_split.slice(1);
            if (name === cookieName) {
                return decodeURIComponent(valueParts.join('='));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var shouldAttachCsrfHeader = function(method) {
    if (!method) {
        return false;
    }
    return unsafeMethods.has(method.toLowerCase());
};
/**
 * 기본 설정
 */ var DEFAULT_CONFIG = {
    timeout: 30000,
    // Do NOT force 'Content-Type' here. Let request-level logic set it
    // so that FormData requests get proper multipart boundaries.
    defaultHeaders: {
        'Accept': 'application/json'
    },
    enableDebug: process.env.NODE_ENV === 'development'
};
/**
 * AuthContext 기반 Axios 인스턴스 생성
 * @param config Axios 인스턴스 설정
 * @returns 인증이 통합된 Axios 인스턴스
 */ export function createAuthAxiosInstance(config) {
    var finalConfig = _object_spread({}, DEFAULT_CONFIG, config);
    // Axios 인스턴스 생성
    var instance = axios.create({
        baseURL: finalConfig.baseURL,
        timeout: finalConfig.timeout,
        headers: finalConfig.defaultHeaders,
        withCredentials: finalConfig.withCredentials
    });
    // Request interceptor - 인증 헤더 자동 추가
    instance.interceptors.request.use(function(requestConfig) {
        // TokenManager에서 현재 액세스 토큰 가져오기
        var accessToken = tokenManager.getToken();
        if (accessToken) {
            if (_instanceof(requestConfig.headers, AxiosHeaders)) {
                requestConfig.headers.set('Authorization', "Bearer ".concat(accessToken));
            } else {
                var _requestConfig_headers;
                requestConfig.headers = (_requestConfig_headers = requestConfig.headers) !== null && _requestConfig_headers !== void 0 ? _requestConfig_headers : {};
                requestConfig.headers.Authorization = "Bearer ".concat(accessToken);
            }
        }
        var needsCsrfHeader = shouldAttachCsrfHeader(requestConfig.method);
        var csrfToken = null;
        if (needsCsrfHeader) {
            csrfToken = getCookieValue(XSRF_COOKIE_NAME);
            if (csrfToken) {
                if (_instanceof(requestConfig.headers, AxiosHeaders)) {
                    if (!requestConfig.headers.has(XSRF_HEADER_NAME)) {
                        requestConfig.headers.set(XSRF_HEADER_NAME, csrfToken);
                    }
                } else {
                    var _requestConfig_headers1;
                    requestConfig.headers = (_requestConfig_headers1 = requestConfig.headers) !== null && _requestConfig_headers1 !== void 0 ? _requestConfig_headers1 : {};
                    if (!(XSRF_HEADER_NAME in requestConfig.headers)) {
                        requestConfig.headers[XSRF_HEADER_NAME] = csrfToken;
                    }
                }
            }
        }
        // 디버그 로깅
        if (finalConfig.enableDebug) {
            var _requestConfig_method;
            console.log('🌐 [API 요청]', {
                method: (_requestConfig_method = requestConfig.method) === null || _requestConfig_method === void 0 ? void 0 : _requestConfig_method.toUpperCase(),
                url: requestConfig.url,
                baseURL: requestConfig.baseURL,
                fullURL: requestConfig.baseURL ? "".concat(requestConfig.baseURL).concat(requestConfig.url) : requestConfig.url,
                hasAuth: !!accessToken,
                hasCsrf: needsCsrfHeader && !!csrfToken,
                timestamp: new Date().toISOString()
            });
        }
        return requestConfig;
    }, function(error) {
        if (finalConfig.enableDebug) {
            console.error('❌ [API 요청 에러]', error);
        }
        return Promise.reject(error);
    });
    // Response interceptor - 인증 에러 처리
    instance.interceptors.response.use(function(response) {
        // 성공 응답 디버그 로깅
        if (finalConfig.enableDebug) {
            console.log('✅ [API 응답]', {
                status: response.status,
                url: response.config.url,
                timestamp: new Date().toISOString()
            });
        }
        return response;
    }, /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(error) {
            var _error_response, originalRequest, _error_config, refreshToken, handleRefreshTokenFlow, authServerUrl, result, refreshError, _error_response1, _error_config1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        originalRequest = error.config;
                        if (!(((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 401 && !originalRequest._retry)) return [
                            3,
                            8
                        ];
                        console.warn('🔐 [인증 만료 감지] URL:', (_error_config = error.config) === null || _error_config === void 0 ? void 0 : _error_config.url, 'retry flag:', originalRequest._retry);
                        if (finalConfig.enableDebug) {
                            console.warn('🔐 [인증 만료] 토큰 리프레시 시도');
                        }
                        // 재시도 플래그 설정 (무한 루프 방지)
                        originalRequest._retry = true;
                        // 리프레시 토큰으로 액세스 토큰 갱신 시도
                        refreshToken = tokenManager.getRefreshToken();
                        console.log('🔐 [리프레시 토큰 확인] 존재:', !!refreshToken, '길이:', (refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.length) || 0);
                        if (!refreshToken) return [
                            3,
                            6
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        console.log('🔐 [리프레시 토큰 갱신 시작] tokenType:', tokenManager.getTokenType());
                        return [
                            4,
                            import('../utils/refresh')
                        ];
                    case 2:
                        handleRefreshTokenFlow = _state.sent().handleRefreshTokenFlow;
                        authServerUrl = finalConfig.authServerUrl || 'https://auth.ugot.uk';
                        return [
                            4,
                            handleRefreshTokenFlow(refreshToken, authServerUrl, tokenManager.getTokenType(), finalConfig.oauthClientId)
                        ];
                    case 3:
                        result = _state.sent();
                        console.log('🔐 [리프레시 토큰 갱신 결과]', {
                            success: result.success,
                            hasAccessToken: !!result.accessToken,
                            error: result.error
                        });
                        if (result.success && result.accessToken) {
                            // 새 토큰 저장
                            if (result.refreshToken) {
                                tokenManager.setRefreshToken(result.refreshToken);
                            }
                            if (result.expiresIn) {
                                tokenManager.setExpiresIn(result.expiresIn);
                            }
                            tokenManager.setToken(result.accessToken, result.tokenType || 'Bearer');
                            // 원래 요청에 새 토큰 추가하여 재시도
                            originalRequest.headers.Authorization = "Bearer ".concat(result.accessToken);
                            return [
                                2,
                                instance(originalRequest)
                            ];
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        refreshError = _state.sent();
                        console.error('❌ [토큰 리프레시 실패]', refreshError);
                        if (finalConfig.enableDebug) {
                            console.error('❌ [토큰 리프레시 실패 - 디버그]', refreshError);
                        }
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        console.warn('🔐 [리프레시 토큰 없음] 토큰 갱신 불가');
                        _state.label = 7;
                    case 7:
                        // 현재는 단순히 로그아웃 처리
                        if (finalConfig.enableDebug) {
                            console.warn('🔐 [인증 만료] 토큰 클리어 및 로그아웃 처리');
                        }
                        // 토큰 클리어
                        tokenManager.clearToken();
                        // 커스텀 인증 에러 핸들러 호출
                        if (finalConfig.onAuthError) {
                            finalConfig.onAuthError();
                        }
                        _state.label = 8;
                    case 8:
                        // 에러 디버그 로깅
                        if (finalConfig.enableDebug) {
                            ;
                            console.error('❌ [API 응답 에러]', {
                                status: (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.status,
                                url: (_error_config1 = error.config) === null || _error_config1 === void 0 ? void 0 : _error_config1.url,
                                message: error.message,
                                timestamp: new Date().toISOString()
                            });
                        }
                        return [
                            2,
                            Promise.reject(error)
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
    return instance;
}
/**
 * Orval용 커스텀 인스턴스 생성 헬퍼
 * @param baseURL API 베이스 URL
 * @param additionalConfig 추가 설정
 * @returns Orval 호환 커스텀 인스턴스 함수
 */ export function createOrvalCustomInstance(baseURL, additionalConfig) {
    // baseURL이 /로 끝나도록 보장
    var normalizedBaseURL = baseURL.endsWith('/') ? baseURL : baseURL + '/';
    var instance = createAuthAxiosInstance(_object_spread({
        baseURL: normalizedBaseURL
    }, additionalConfig));
    // Orval이 기대하는 커스텀 인스턴스 함수 형태
    return function customInstance(config, options) {
        var source = axios.CancelToken.source();
        // URL 처리: baseURL 끝에 /가 없으면 추가하고, URL 앞의 /는 제거
        var processedConfig = _object_spread({}, config);
        // baseURL이 /로 끝나지 않으면 추가
        var effectiveBaseURL = baseURL;
        if (effectiveBaseURL && !effectiveBaseURL.endsWith('/')) {
            effectiveBaseURL = effectiveBaseURL + '/';
        }
        // URL이 /로 시작하면 제거
        if (processedConfig.url && processedConfig.url.startsWith('/')) {
            processedConfig.url = processedConfig.url.substring(1);
        }
        // baseURL을 config에 명시적으로 설정
        processedConfig.baseURL = effectiveBaseURL;
        // 디버그: config와 options 확인
        console.log('🔍 Orval customInstance 호출:', {
            originalUrl: config.url,
            processedUrl: processedConfig.url,
            effectiveBaseURL: effectiveBaseURL,
            finalURL: "".concat(effectiveBaseURL).concat(processedConfig.url),
            options: options
        });
        var promise = instance(_object_spread_props(_object_spread({}, processedConfig, options), {
            cancelToken: source.token
        })).then(function(param) {
            var data = param.data;
            return data;
        });
        // @ts-ignore - Orval에서 기대하는 cancel 메서드 추가
        promise.cancel = function() {
            source.cancel('Query was cancelled');
        };
        return promise;
    };
}
